/**
 * 事件总线，单例，会触发事件
 */
import EventEmitter from 'events';
import EventTypes from '../event-bus/event-types';

class EventBus {
  // 持有单例
  private static _ins: EventBus;

  // 事件触发器实例
  private _emitter: EventEmitter | null = null;

  private constructor() {
    if (EventBus._ins) {
      return EventBus._ins;
    }
    this._emitter = new EventEmitter();
    EventBus._ins = this;
    return this;
  }

  private static get instance() {
    if (EventBus._ins) {
      return EventBus._ins;
    }
    return new EventBus();
  }

  /**
   * 获取事件总线的Emitter
   */
  public static get emitter() {
    return EventBus.instance._emitter!;
  }

  /**
   * 初始化事件总线
   */
  public static init() {
    return EventBus.instance;
  }
}

export default EventBus;

export { EventTypes };
